import io from 'socket.io-client'

import { getToken } from 'utils/cookies'

let socket = null

const createSocket = () => {
  if (socket) return socket

  socket = io(process.env.REACT_APP_API_BASE_URL, {
    auth: (cb) => cb({ token: getToken() }),
  })

  return socket
}

export const disconnectSocket = () => {
  if (!socket) return

  socket.disconnect()
  socket = null
}

export default createSocket
